import { Grid, Filter, Page, Sort, RecordClickEventArgs, parentsUntil, Toolbar, Edit, QueryCellInfoEventArgs, Column, RowSelectingEventArgs } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { DropDownList, ChangeEventArgs } from '@syncfusion/ej2-dropdowns';
import { DatePicker, DateTimePicker } from '@syncfusion/ej2-calendars';
// import { Toastr } from '../Helpers/Toastr';
// import { UserDataService } from '../DataService/UserDataService';
import { DynamicVariables } from '../../Common/DynamicVariables';
import { Dropdown } from 'bootstrap';
import { WorkloadManagerDataService } from '../../DataService/WorkloadManagerDataService';
import { SyncfusionDropdownHelper } from '../../Helpers/SyncfusionDropdownHelper';
import { WorkloadItemStatus } from '../../Models/Workload/WorkloadItemStatus';
import { DateHelper } from '../../Helpers/DateHelper';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { CheckBox } from '@syncfusion/ej2/buttons';
import { ProjectMassAssignPopupManager } from './ProjectMassAssignPopupManager';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';
// import { ModalHelper } from '../Helpers/ModalHelper';
// import { ConfirmModal } from '../Helpers/ConfirmModal';

export class WorkloadIndexManager {

    constructor(private containerElement: JQuery) { }

    private workbookGrid : Grid;

    private massAssignModalHelper : ModalHelper;
    private massAssignManager : ProjectMassAssignPopupManager;


    public initialize() {
        var self = this;

        Grid.Inject(Filter, Page, Sort, Toolbar, Edit);

        self.initializeDataWarehouseDocumentsTable();
    }

    private initializeDataWarehouseDocumentsTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var workloadContainer = self.containerElement.find('#workload-container');
        var massAssignButton = self.containerElement.find('#mass-assign-button');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#WorkloadManagerProjectWorkloadGrid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;

        let data: DataManager = new DataManager({
            url: '/api/company/workload/list',
            adaptor: new WebApiAdaptor,
        });

        var selectAllElem;
        var selectAllObj;

        var creationDateElem;
        var creationDateObj;

        var quoteDateElem;
        var quoteDateObj;

        var dueDateElem;
        var dueDateObj;

        var purchaserSelectElement;
        var purchaserSelectObject;
        var purchasers : any;

        var selectedRowId : string;

        self.massAssignModalHelper = new ModalHelper();
        self.massAssignModalHelper.createModal("workload-mass-assign-popup", true);

        const assignedPurchasers: {key: string, value: string}[] = [];

        var lastSetPurchaserName : string | undefined = undefined;

        var selectedRowIds = [];

        WorkloadManagerDataService.getWorkloadPurchasers((result) => {
            purchasers = result;
            var purchasersForFilters = result;
            purchasersForFilters = [{purchaserId: "00000000-0000-0000-0000-000000000000", purchaserName: "<Unassigned>"}].concat(purchasersForFilters);

            self.workbookGrid = new Grid(
                {
                    height: '100%',
                    toolbarTemplate: '#toolbar-template',
                    dataSource: data,
                    editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
                    columns: [
                        { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                        { field: 'Selected', headerText: '', allowFiltering: true, allowEditing: false, width:40, template: '${getWorkloadItemCheckbox(data.Id)}',
                            filterBarTemplate: {
                                create: () => { 
                                    var newCheckbox = document.createElement("input");
                                    newCheckbox.type = "checkbox";
                                    newCheckbox.style.width = '13px';
                                    newCheckbox.style.height = '13px';
                                    newCheckbox.style.marginTop = '0.25rem';

                                    var parsedCheckbox = $(newCheckbox);
                                    parsedCheckbox.off('change').on('change', () => {
                                        var checked = parsedCheckbox.is(':checked');
                                        
                                        workloadContainer.find(`input[data-item-id]`).each((index, element) => {
                                            var parsedCheckboxElement = $(element);
                                            var itemId = parsedCheckboxElement.data('item-id');

                                            parsedCheckboxElement.prop('checked', checked); 

                                            if(checked) {
                                                if(selectedRowIds.indexOf(itemId) == -1) {
                                                    selectedRowIds.push(itemId);
                                                }
                                            }
                                            else {
                                                const index = selectedRowIds.indexOf(itemId);
                                                if (index > -1) {
                                                    selectedRowIds.splice(index, 1); // 2nd parameter means remove one item only
                                                }
                                            }
                                        });

                                        if(checked) {
                                            massAssignButton.prop('disabled', false); 
                                        }
                                        else {
                                            if(selectedRowIds.length <= 0) {
                                                massAssignButton.prop('disabled', true);
                                            }
                                        }
                                    })

                                    return newCheckbox;
                                  }, 
                                  write: (args) => { 
                                    // selectAllObj = new CheckBox({ 
                                    //     // value: new Date(args.column.field), 
                                    //     // format: "dd-MM-yyyy",
                                    //     // floatLabelType: 'Never', 
                                    //     // change: (args) => {
                                    //     //     var dateValue = DateHelper.DateToString(args.value);
                                    //     //     if(dateValue == undefined) {
                                    //     //         self.workbookGrid.removeFilteredColsByField("CreationDateTimeString");
                                    //     //     }
                                    //     //     else {
                                    //     //         self.workbookGrid.filterByColumn("CreationDateTimeString", 'equal', dateValue, undefined, true);
                                    //     //     }
                                    //     // }
                                    // }, selectAllElem); 
                                    // selectAllObj.appendTo(selectAllElem); 
                                  } 
                            }
                        },
                        { field: 'CreationDateTimeString', headerText: 'Date',  width: 75, allowEditing: false, allowFiltering: true,
                            filterBarTemplate: {
                                create: () => { 
                                    creationDateElem = document.createElement('input'); 
                                    return creationDateElem; 
                                }, 
                                write: (args) => {
                                    const persistedValue =
                                        args?.value
                                        ?? self.workbookGrid?.filterSettings?.columns
                                            ?.find((x: any) => x.field === 'CreationDateTimeString')
                                            ?.value;

                                    creationDateObj = new DatePicker({
                                        value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                        format: 'dd-MM-yyyy',
                                        floatLabelType: 'Never',

                                        change: (args) => {
                                            const dateValue = DateHelper.DateToString(args.value);

                                            if (dateValue == undefined) {
                                                self.workbookGrid.removeFilteredColsByField(
                                                    'CreationDateTimeString'
                                                );
                                            } else {
                                                self.workbookGrid.filterByColumn(
                                                    'CreationDateTimeString',
                                                    'equal',
                                                    dateValue,
                                                    undefined,
                                                    true
                                                );
                                            }
                                        }
                                    });
                                    creationDateObj.appendTo(creationDateElem); 
                                  } 
                            }
                        },
                        { field: 'OurReference', headerText: 'Our ref',  width: 75, allowEditing: false, allowFiltering: true},
                        { field: 'AmountOfLines', headerText: '#',  width: 50, allowEditing: false, allowFiltering: true, textAlign: 'Right', filter: {
                            type: "number"
                        }},
                        { field: 'VesselName', headerText: 'Vessel', width: 150, allowEditing: false},
                        { field: 'CustomerName', headerText: 'Customer',  width: 150, allowEditing: false},
                        
                        { field: 'CustomerReference', headerText: 'Customer ref', width: 100, allowEditing: false, allowFiltering: true},
                        { field: 'Department', headerText: 'Deparment', width: 100, allowEditing: false, allowFiltering: true},
                        { field: 'AssignedPurchaserId', visible: false, allowEditing: true, allowSorting: false},
                        {
                            field: 'AssignedPurchaser', headerText: 'Operator', width: 125, allowEditing: true, type:'dropdownedit', allowFiltering: true, allowSorting: false,
                            filterBarTemplate: self.templatePurchasersDropDown('AssignedPurchaserId', purchasersForFilters),
                        },
                        { field: 'Status', headerText: 'Status', width: 75, allowSorting: false, allowEditing: false, allowFiltering: true, filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.workbookGrid, 'StatusText', Object.keys(WorkloadItemStatus).filter(key => isNaN(Number(key))), 
                            (args) => {
                            if (args.value !== 'All') {
                                self.workbookGrid.filterByColumn("Status", 'equal', args.value, undefined, true);
                            } else {
                                self.workbookGrid.removeFilteredColsByField("Status");
                            }
                        })},
                        { field: 'QuoteDate', headerText: 'When Quote', width: 100, allowEditing: false, allowFiltering: true, editType: 'datetimepickeredit',
                            filterBarTemplate: {
                                create: () => { 
                                    quoteDateElem = document.createElement('input'); 
                                    return quoteDateElem; 
                                    }, 
                                write: (args) => {
                                    const persistedValue =
                                        args?.value
                                        ?? self.workbookGrid?.filterSettings?.columns
                                            ?.find((x: any) => x.field === 'QuoteDate')
                                            ?.value;

                                    quoteDateObj = new DatePicker({
                                        value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                        format: 'dd-MM-yyyy',
                                        floatLabelType: 'Never',

                                        change: (eventArgs) => {
                                            const dateValue = DateHelper.DateToString(eventArgs.value);

                                            if (dateValue == undefined) {
                                                self.workbookGrid.removeFilteredColsByField('QuoteDate');
                                            } else {
                                                self.workbookGrid.filterByColumn(
                                                    'QuoteDate',
                                                    'equal',
                                                    dateValue,
                                                    undefined,
                                                    true
                                                );
                                            }
                                        }
                                    });
                                    quoteDateObj.appendTo(quoteDateElem); 
                                  } 
                            }
                        },
                        { field: 'DueDateValue', headerText: 'Due date', width: 150, allowEditing: true, allowFiltering: true, editType: 'datetimepickeredit',
                            edit: { 
                                params: {
                                    format:'dd-MM-yyyy HH:mm',
                                }
                            },
                            filterBarTemplate: {
                                create: () => { 
                                    dueDateElem = document.createElement('input'); 
                                    return dueDateElem; 
                                }, 
                                write: (args) => {
                                    const persistedValue =
                                        args?.value
                                        ?? self.workbookGrid?.filterSettings?.columns
                                            ?.find((x: any) => x.field === 'DueDateValue')
                                            ?.value;

                                    dueDateObj = new DatePicker({
                                        value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                        format: 'dd-MM-yyyy',
                                        floatLabelType: 'Never',

                                        change: (eventArgs) => {
                                            const dateValue = DateHelper.DateToString(eventArgs.value);

                                            if (dateValue == undefined) {
                                                self.workbookGrid.removeFilteredColsByField('DueDateValue');
                                            } else {
                                                self.workbookGrid.filterByColumn(
                                                    'DueDateValue',
                                                    'equal',
                                                    `${dateValue} 00:00`,
                                                    undefined,
                                                    true
                                                );
                                            }
                                        }
                                    });
                                    dueDateObj.appendTo(dueDateElem); 
                                  } 
                            }
                        },
                    ],
                    allowSorting: true,
                    allowPaging: true,
                    allowFiltering: true,
                    allowSelection: false,
                    allowResizing: false,
                    enablePersistence: true,
                    queryCellInfo: customiseCell,
                    recordClick: (e) => {
                        if($(e.target).is('input')) {
                            return;
                        }

                        workloadContainer.find(`input[data-item-id='${e.rowData.Id}']`).trigger('click');
                    },
                    recordDoubleClick: (e) => {
                        self.startSingleAssign(e.rowData.Id);
 
                        return;
                    },
                    //actionComplete: actionComplete,
                    pageSettings: { pageSize: 50 },
                    created: () => {
                        gridContentElement = gridContentElement.find('.e-content')
        
                        loadingContainer.addClass('d-none');
                        workloadContainer.removeClass('d-none');
                    },
                    actionBegin: (args) => {
                        if (!this.workbookGrid) {
                            return;
                        }

                        if (SyncfusionGridHelper.isFilterAction(args)) {
                            this.workbookGrid.pageSettings.currentPage = 1;
                        }
                    },                    
                    dataBound: () => {
                        selectedRowIds = [];
                        workloadContainer.find('input[data-item-id]').each((index, element) => {
                            $(element).off('change').on('change', function() {
                                var itemId = $(element).data('item-id');
                                if($(element).is(':checked')) {
                                    massAssignButton.prop('disabled', false);
                                    selectedRowIds.push(itemId);
                                }
                                else {
                                    const index = selectedRowIds.indexOf(itemId);
                                    if (index > -1) {
                                        selectedRowIds.splice(index, 1); // 2nd parameter means remove one item only
                                    }
                
                                    if(selectedRowIds.length <= 0) {
                                        massAssignButton.prop('disabled', true);
                                    }
                                }
                            });
                        });
                    }
                });
                
                self.workbookGrid.appendTo('#WorkloadManagerProjectWorkloadGrid');

                var toolbar = this.containerElement.find('#toolbar-template');
                if(toolbar != undefined && toolbar.length > 0) {
                    var clearFiltersButton = toolbar.find('#clear-filters-button');
                    clearFiltersButton.off('click').on('click', () => {
                        self.workbookGrid.pageSettings.currentPage = 1;
                        self.workbookGrid.clearFiltering();
                        self.workbookGrid.refreshHeader();
                    })
                }

                function rowSelecting(args: RowSelectingEventArgs):void
                {
                    if (args.target && args.target.classList.contains('e-icons')) {
                        self.workbookGrid.clearSelection();
                    }
                }

                function customiseCell(args: QueryCellInfoEventArgs) {
                    if(((args.column)as Column).field === 'DueDateValue') {
                        if(args.data != undefined) {
                            let status : any = args.data['DueDateStatus'];
                            let dueDateToday : any = args.data['DueDateToday'];

                            if(status === 'EXPIRED') {
                                ((args.cell)as Element).classList.add('bg-light-red');
                                //((args.cell)as Element).classList.add('text-white');
                            }
                            else if(status === 'COMPLETED') {
                                ((args.cell)as Element).classList.add('bg-light-green');
                                //((args.cell)as Element).classList.add('text-white');
                            }

                            else if(status === 'COMPLETED') {
                                ((args.cell)as Element).classList.add('bg-light-green');
                                //((args.cell)as Element).classList.add('text-white');
                            }
                            else {
                                if(dueDateToday == 'true' || dueDateToday == 'True' || dueDateToday == true) {
                                    ((args.cell)as Element).classList.add('bg-light-yellow');
                                }
                            }
                        }
                        // let freightData= args.data['Freight'];
                        // if (freightData <= 30){
                        //     
                        // } else if(freightData > 30 && freightData < 80 ) {
                        //     ((args.cell)as Element).classList.add('below-80');
                        // } else {
                        //     ((args.cell)as Element).classList.add('above-80');
                        // }
                    }
                }
        });


        massAssignButton.off('click').on('click', () => {
            if(selectedRowIds.length <= 0) {
                return;
            }

            self.massAssignModalHelper.loadWithPost('?handler=StartProjectMassAssign', {
                "SelectedWorkloadItemIds": selectedRowIds
            }, undefined, () => {
                if(self.massAssignManager == undefined) {
                    self.massAssignManager = new ProjectMassAssignPopupManager(self.massAssignModalHelper.getModalContainer());
                }

                self.massAssignManager.initialize();
            });
        });

        (<any>window).initializeProjectMassAssign = () => {
            if(self.massAssignModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.workbookGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
                //self.workbookGrid.refreshColumns();
                //self.workbookGrid.refresh();
                selectedRowIds = [];
                massAssignButton.prop('disabled', true);
            }
            else {
                self.massAssignManager.initialize();
            }
        }

        
 

        //TODO: Roles based on plugins



        //add-user-button

        // function actionComplete(args) {
        //     console.log(args);
        //     if ((args.requestType == 'save')) {
        //         args.promise.then((result) => {
        //             if(result.isSuccessStatusCode == false) {
        //                 Toastr.Error("Error when saving the changes to the user.", args.reasonPhrase);
        //             }
        //         })
        //     }
        // }

        // var toolbar = this.containerElement.find('#toolbar-template');
        // if(toolbar != undefined && toolbar.length > 0) {
        //     var addButton = toolbar.find('#add-user-button');
        //     addButton.off('click').on('click', () => {
        //         self.addUserModalHelper.load(`?handler=AddUser`, undefined, () => {

        //         }, 
        //         undefined);
        //     })
        // }

        // (<any>window).initializeAddUser = () => {
        //     if(self.addUserModalHelper.getModalContainer().find('.alert-danger').length == 0) {
        //         self.workbookGrid.refresh();
        //     }
        //     // else {
        //     //     self.addManualProjectManager.initialize();
        //     // }
        // }
    }
    
    private startSingleAssign(workloadItemId) {
        var self = this;

        self.massAssignModalHelper.loadWithPost('?handler=StartProjectMassAssign', {
            "SelectedWorkloadItemIds": [workloadItemId]
        }, undefined, () => {
            if(self.massAssignManager == undefined) {
                self.massAssignManager = new ProjectMassAssignPopupManager(self.massAssignModalHelper.getModalContainer());
            }

            self.massAssignManager.initialize();
        });
    }

    private templatePurchasersDropDown(column: string, options: any[]) {
        const self = this;

        let dropdown: HTMLSelectElement;
        let dropdownList: DropDownList;

        const getPersistedFilterValue = (): string | undefined => {
            const filterColumn = self.workbookGrid?.filterSettings?.columns
                ?.find((x: any) => x.field === column);

            return filterColumn?.value?.toString();
        };

        const dropdownOptions = {
            create: () => {
                dropdown = document.createElement('select');
                dropdown.id = column;

                const allOption = document.createElement('option');
                allOption.value = 'All';
                allOption.innerText = '<All>';
                dropdown.appendChild(allOption);

                options.forEach((item) => {
                    const option = document.createElement('option');
                    option.value = item?.purchaserId?.toString();
                    option.innerText = item?.purchaserName?.toString();
                    dropdown.appendChild(option);
                });

                return dropdown;
            },

            write: (args) => {
                const value =
                    args?.value?.toString()
                    ?? getPersistedFilterValue()
                    ?? 'All';

                dropdownList = new DropDownList({
                    value: value,

                    change: (args) => {
                        if (args.value !== 'All') {
                            self.workbookGrid.filterByColumn(
                                column,
                                'equal',
                                args.value,
                                undefined,
                                true
                            );
                        } else {
                            self.workbookGrid.removeFilteredColsByField(column);
                        }
                    }
                });

                dropdownList.appendTo(dropdown);
            }
        };

        return dropdownOptions;
    }
}